import { registerSW } from 'virtual:pwa-register'
import { setPwaUpdater } from './pwa-update'
import type { Tel } from '@w/tel'

const UPDATE_INTERVAL_MS = 60 * 1000

export function registerAppUpdates(tel: Tel) {
  let serviceWorkerRegistration: ServiceWorkerRegistration | null = null
  let updateSW: ((reloadPage?: boolean) => Promise<void>) | undefined
  void tel
    .span({ name: 'serviceWorker.register', input: undefined, target: 'broker' }, () =>
      new Promise<void>((resolve, reject) => {
        updateSW = registerSW({
          immediate: true,
          onNeedRefresh() {
            void updateSW?.(true).catch(error => { tel.error(error, { operation: 'serviceWorker.activate' }) })
          },
          onRegisterError(error) {
            reject(error instanceof Error ? error : new Error(String(error)))
          },
          onRegisteredSW(_swUrl, registration) {
            if (!registration) { resolve(); return }
            serviceWorkerRegistration = registration

            window.setInterval(() => {
              void registration.update().catch(error => { tel.error(error, { operation: 'serviceWorker.update' }) })
            }, UPDATE_INTERVAL_MS)
            resolve()
          },
        })
      }),
    )
    .catch(error => { tel.error(error, { operation: 'serviceWorker.register' }) })
  setPwaUpdater(async () => {
    await serviceWorkerRegistration?.update()
  })
}

export function markAppReady(): void {}
